"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuexClass = require("vuex-class");

var _vuePropertyDecorator = require("vue-property-decorator");

var _elementUi = require("element-ui");

var _milkRunV = require("@/mixins/milk-run-v2/milk-run-v2");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var MRGanttFilterComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(MRGanttFilterComponent, _Mixins);

  var _super = _createSuper(MRGanttFilterComponent);

  function MRGanttFilterComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, MRGanttFilterComponent);
    _this = _super.apply(this, arguments);
    _this.timeSteppers = [10, 30, 60, 120, 240, 360];
    _this.timeStepper = 10;
    _this.routeViewOptions = ['plannedRoutes', 'suggestedRoutes', 'actualRoutes'];
    _this.routeViews = ['plannedRoutes', 'actualRoutes'];
    _this.cargoTruckVal = null;
    _this.isAutoScrolling = true;
    _this.alertType = [];
    return _this;
  }

  (0, _createClass2.default)(MRGanttFilterComponent, [{
    key: "onRouteViewsChanges",
    value: function onRouteViewsChanges(newVal) {
      this.$emit('onRouteViewsChanges', newVal);
    }
  }, {
    key: "onPlanDateRangeChanges",
    value: function onPlanDateRangeChanges(newVal, oldVal) {
      this.cargoTruckVal = null;
    }
  }, {
    key: "$selectedProjects",
    get: function get() {
      return this.$store.getters['milkRunV2/selectedProjects'];
    },
    set: function set(newVal) {
      this.$setSelectedProjects(newVal);
    }
  }, {
    key: "$selectedCustomers",
    get: function get() {
      return this.$store.getters['milkRunV2/selectedCustomers'];
    },
    set: function set(newVal) {
      this.$setSelectedCustomers(newVal);
    }
  }, {
    key: "$selectedTrucks",
    get: function get() {
      return this.$store.getters['milkRunV2/selectedTrucks'];
    },
    set: function set(newVal) {
      this.$setSelectedTrucks(newVal);
    }
  }, {
    key: "currentPlanOrdersLen",
    get: function get() {
      if (this.helper.isUndefined(this.$plan.orders)) {
        return 0;
      }

      return this.$plan.orders.length;
    }
  }, {
    key: "created",
    value: function created() {
      this.routeViews = this.defaultRViews;
    }
  }, {
    key: "handleTimeStepperChanges",
    value: function handleTimeStepperChanges(newVal) {
      this.$emit('onTimeStepperChanges', newVal);
    }
    /*handlePlay() {
      this.$emit('onGCPlay');
    }
       handlePause() {
      this.$emit('onGCPause');
    }*/

  }, {
    key: "getData",
    value: function getData() {
      this.$emit('getData');
      this.handleAlertChange(this.alertType);
    }
  }, {
    key: "handleAutoScrollingChange",
    value: function handleAutoScrollingChange(newVal) {
      if (newVal) {
        this.$emit('onGCPlay');
      } else {
        this.$emit('onGCPause');
      }
    }
  }, {
    key: "handleAlertChange",
    value: function handleAlertChange(newVal) {
      this.$emit('handleAlertChange', newVal);
    }
  }]);
  return MRGanttFilterComponent;
}((0, _vuePropertyDecorator.Mixins)(_milkRunV.MilkRunV2Mixin));

(0, _tslib.__decorate)([(0, _vuexClass.Getter)('projectCodes', {
  namespace: 'common'
})], MRGanttFilterComponent.prototype, "$projectCodes", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('customers', {
  namespace: 'common'
})], MRGanttFilterComponent.prototype, "$customers", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('trucks', {
  namespace: 'milkRunV2'
})], MRGanttFilterComponent.prototype, "$trucks", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_SELECTED_PROJECTS', {
  namespace: 'milkRunV2'
})], MRGanttFilterComponent.prototype, "$setSelectedProjects", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_SELECTED_CUSTOMERS', {
  namespace: 'milkRunV2'
})], MRGanttFilterComponent.prototype, "$setSelectedCustomers", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_SELECTED_TRUCKS', {
  namespace: 'milkRunV2'
})], MRGanttFilterComponent.prototype, "$setSelectedTrucks", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: false
})], MRGanttFilterComponent.prototype, "isAutoAssign", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Array,
  default: ['plannedRoutes']
})], MRGanttFilterComponent.prototype, "defaultRViews", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: false
})], MRGanttFilterComponent.prototype, "isVerticallyAutoScrolling", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: false
})], MRGanttFilterComponent.prototype, "isDashboard", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: true
})], MRGanttFilterComponent.prototype, "isPlay", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: false
})], MRGanttFilterComponent.prototype, "isPause", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('routeViews')], MRGanttFilterComponent.prototype, "onRouteViewsChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('$planDateRange')], MRGanttFilterComponent.prototype, "onPlanDateRangeChanges", null);
MRGanttFilterComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'MRGanttFilterComponent',
  components: {
    'el-form': _elementUi.Form,
    'el-form-item': _elementUi.FormItem,
    'el-select': _elementUi.Select,
    'el-option': _elementUi.Option,
    'el-tag': _elementUi.Tag,
    'el-input': _elementUi.Input,
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-switch': _elementUi.Switch,
    'el-button': _elementUi.Button,
    'el-tooltip': _elementUi.Tooltip,
    'el-date-picker': _elementUi.DatePicker
  }
})], MRGanttFilterComponent);
var _default = MRGanttFilterComponent;
exports.default = _default;